import { areaEn } from './areaEn'
// 英文
export const getAreaCountryEn = () => {
  let countryArray = []
  for (let a in areaEn) {
    countryArray.push({
      name: a
    })
  }
  return countryArray
}
export const getAreaProvinceEn = d => {
  let countryProvince = areaEn[d]
  let provinceArray = []
  for (let a in countryProvince) {
    provinceArray.push({
      name: a
    })
  }
  return provinceArray
}
export const getAreaCityEn = (d, b) => {
  let countryCity = areaEn[d][b]
  let cityArray = []
  if (countryCity) {
    countryCity.forEach(a => {
      cityArray.push({
        name: a
      })
    })
  }
  return cityArray
}
